import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Sound } from 'components/alphabet/sound'
import { breakpoints } from 'styles/mq'
import AlphabetDots from './assets/Alphabet_dots.svg'
import AlphabetDotsMobile from './assets/Alphabet_dots-mobile.svg'
import { Picture, ImageWrapper, Title, StyledActiveArea } from './styled'

type Props = {}

const chars = ['ДЖ', 'ДЗ', 'ЗЬ', 'О', 'СЬ', 'ТШ']

export const Alphabet = forwardRef<HTMLDivElement, Props>((_, ref) => (
  <section ref={ref}>
    <Title data-menu-title="коми алфавит">
      <TextContainer>Коми алфавит</TextContainer>
    </Title>

    <TextContainer>
      <p>
        В 1372 году миссионер из Московского княжества Стефан Храп (Пермский){' '}
        <a
          href="https://postnauka.ru/longreads/155705"
          target="_blank"
          rel="noreferrer"
        >
          создал
        </a>{' '}
        анбур – первый коми алфавит, названный так же, как и азбука, по первым
        буквам – "ан" и "бур". В основе анбура – оригинальные буквы,
        вдохновленные кириллицей и греческим алфавитом, а также пасы – родовые
        знаки коми-зырян, коми-пермяков и коми-язьвинцев. Анбур активно
        использовался для христианизации коми в 1380 году и аж до XVIII века.
      </p>

      <p>
        В начале XIX века впервые была составлена грамматика коми-зырянского
        языка – в основе ее была кириллица с добавлением букв "ӧ" и "ӵ". А уже в
        1938 году утвердили современный коми алфавит. В его основе все та же
        кириллица, а также уже знакомые "ӧ" и "i". Для обозначения аффрикат
        используются диграфы "дж", "дз" и "тш". Мягкость согласных обозначается
        мягким знаком, стоящим после них.
      </p>

      <p>
        Так выглядит современный коми алфавит. Чтобы услышать, как произносятся
        некоторые буквы, нужно навести курсор
      </p>

      <ImageWrapper>
        <Picture>
          <source srcSet={AlphabetDots} media={breakpoints.medium} />
          <img src={AlphabetDotsMobile} alt="" />
        </Picture>

        {chars.map((char, index) => (
          <Sound
            key={index}
            char={char}
            chapter="komi"
            ActiveAreaComponent={StyledActiveArea}
          />
        ))}
      </ImageWrapper>
    </TextContainer>
  </section>
))
